import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import _ from 'underscore';
import { CheckboxSelect } from '@atlaskit/select';
var xtend = require('xtend');

import CreateCategoryModal from '../../../../metadata/components/categories/modals/CreateCategoryModal'
import RestrictedComponent, { hasPermission } from '../../../../lib/components/form/RestrictedComponent';
import { getContentGroupData, getHasRequestPending } from '../../../../redux/data/selectors';
import { sortByParent } from '../../../../embed/hoc/types/CategorySelect';
import Loader from '../../../../common/components/notifications/Loader';
import schema from '../../../../routes/permissions/schema';

function EventCategories (props) {
    const { hiddenSelectedCategories, pendingCategories } = props
    const [fixedData, fixedNested, newCategories] = fixOptions(props.data, props.nested)
    var [editedCategories, setEditedCategories] = useState(getAssignedCats(fixedData, fixedNested, props.selected))
    const [createModal, setCreateModal] = useState(false)
    const selectOptions = createSelectOptions(fixedData, fixedNested)
    useEffect(() => {
        // reset categories if they were in progress of loading
        if (props.data) {
            const [data, nested,categories] = fixOptions(props.data, props.nested)
            setEditedCategories(getAssignedCats(data, nested, props.selected))
        }
    }, [props.data])
    newCategories.forEach(category => {
        const tempNew = {
            label: category.categoryName,
            value: category.categoryID,
            description: category.categoryDescription,
            childrenLength: null, // new categories cannot immediately have children but can have a parent
            isChild: !!category.parentCategoryID,
            parentID: category.parentCategoryID || null
        }
        let tempParent
        if (category.parentCategoryID) {
            // check that if the parent hasn't already been added to edited categories add it
            let foundParent = false
            if (editedCategories && editedCategories.length) {
                editedCategories.forEach(category => {
                    if (category.value === category.parentCategoryID) {
                        foundParent = true
                    }
                })
            }
            if (!foundParent) {
                fixedData.forEach(cat => {
                    if (cat.categoryID === category.parentCategoryID) {
                        tempParent = {
                            label: cat.categoryName,
                            value: cat.categoryID,
                            description: cat.categoryDescription,
                            childrenLength: Object.keys(fixedNested[cat.categoryID]).length,
                            isChild: false,
                            parentID: null
                        }
                    }
                })
            }
        }
        const newEditedCategories = editedCategories && editedCategories.length ? [...editedCategories] : []
        if (tempParent) newEditedCategories.push(tempParent)
        newEditedCategories.push(tempNew)
        setEditedCategories(newEditedCategories)
    })
    function onChange (ev, msg) {

        // if (ev.length === 0 && props.isAssignedGroup) {
        //     return setEditedCategories(props.data.map(cat => createOption(cat, fixedNested)))
        // }

        // when you unslect a parent, you should unselect all children as well
        if (msg.action === 'deselect-option' || msg.action === 'remove-value') {
            // if this was a parent category

            const removedValue = msg.action === 'deselect-option' ? msg.option.value : msg.removedValue.value
            if (fixedNested[removedValue]) {
                var newState = ev.filter(function (cat) {
                    return cat.parentID !== removedValue
                })
                return setEditedCategories(newState)
            }
        }

        // if you select a child category, we must select the parent as well
        var newState = ev.reduce(function (acc, cat) {
            if (!cat.isChild) {
                acc.push(cat)
                return acc
            }

            var parent = _.findWhere(ev, { value: cat.parentID })
            if (!parent) {
                var _parent = _.findWhere(fixedData, {
                    categoryID: cat.parentID
                })
                acc.push(createOption(_parent, fixedNested))
            }
            acc.push(cat)
            return acc
        }, [])

        setEditedCategories(newState)
    }

    function reset (ev) {
        ev.preventDefault()
        setEditedCategories(null)
    }

    function save (ev) {
        ev.preventDefault()
        const toSave = [...editedCategories]
        for (let i = 0; i < hiddenSelectedCategories.length; i++) {
            toSave.push(createOption(hiddenSelectedCategories[i], fixedNested))
        }

        // list of category IDs
        props.actions.editEvent({
            categories: toSave.map(cat => cat.value)
        })
    }

    const saveAction = (category) => {
        props.actions.add(category, function() {
            setCreateModal(!createModal)
        })
    }

    const valid = category => {
        var failed = [], messages = [];

        if (category.categoryName === '') {
            failed.push('categoryName');
            messages.push('Category Name is Required');
        }

        if (failed.length) {
            setValidators(failed)

            NotifcationActions.notify({
                type: 'warning',
                messages: messages
            });

            return false;
        }

        return true;
    }

    const saveNewCategoryModal = (category, addEvent) => {
        if(valid(category)) {
            if(!!category.parentCategoryID) {
                category.childOf = category.parentCategoryID.value
                delete category.parentCategoryID
            }
            addEvent(category)
            setCreateModal(false)
        }
    }
    let saveDisabled = props.isAssignedGroup && editedCategories.length == 0
    if (pendingCategories) return <Loader/>
    return <div className="tab-categories">
        <div className="category-form">
            <div className="inv-form-label">
                Add or remove categories
            </div>
            <div style={{display:'flex'}}>
                <div style={saveDisabled ? {width: '90%', marginRight: '1rem', border: '1px solid red'} : {width: '90%', marginRight: '1rem'}}>
                    <RestrictedComponent permissionCheck={schema.EVENT_TAB_CATEGORIES.UPDATE}>
                        <CheckboxSelect
                            autoFocus={hasPermission('event_tab_categories.update') ? true : false}
                            className="checkbox-select category-select"
                            classNamePrefix="select"
                            formatOptionLabel={formatOptionLabel}
                            options={selectOptions}
                            placeholder="Add a category"
                            value={editedCategories || getAssignedCats(fixedData, fixedNested, props.selected)}
                            styles={{
                                option:  (styles, {data}) => {
                                    // keep normal styles for unnested categories
                                    // categories with parents should be indented
                                    if (!data.isChild || (!props.data.some(category => category.categoryID === data.parentID))) return styles
                                    return xtend(styles, { marginLeft: '1em' })
                                  }
                            }}
                            onChange={onChange}
                        />
                    </RestrictedComponent>
                </div>
                <div style={{minWidth: '31rem'}}>
                    <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CATEGORIES.CREATE}>
                        <button className="btn btn-primary" style={{marginRight: '1rem'}}
                            onClick={() => setCreateModal(!createModal)}
                        >
                            <i className="fa fa-plus"/> New Category
                        </button>
                    </RestrictedComponent>
                    <button className="btn btn-default" style={{marginRight: '1rem'}}
                        disabled={!editedCategories || props.isResolving}
                        onClick={reset}
                    >
                        <i className="fa fa-undo"/> Reset
                    </button>

                    <RestrictedComponent permissionCheck={schema.EVENT_TAB_CATEGORIES.UPDATE}>
                        <button className="btn btn-success"
                            disabled={saveDisabled || props.isResolving}
                            onClick={save}
                        >
                            <i className="fa fa-save"/> Save
                        </button>
                    </RestrictedComponent>
                </div>
            </div>
            {saveDisabled ? <div>
                You must select a category from your content group
            </div> : null}
        </div>
        {createModal ? <CreateModal
            data={fixedData}
            save={category => saveNewCategoryModal(category, saveAction)}
            createModal={createModal}
            toggleCreateModal={() => setCreateModal(!createModal)}
        /> : null}
    </div>
}

const CreateModal = props => {
    const {data, save, createModal, toggleCreateModal} = props
    const categories = []
    data.map(category => {
        if (category.parentCategoryID === null) {
            categories.push(
                { value: category.categoryID, label: category.categoryName}
            )
        }
    })
    return <CreateCategoryModal
        save={save}
        categories={categories}
        createModal={createModal}
        toggleCreateModal={toggleCreateModal}
    />
}

function getAssignedCats (data, nested, selected) {
    var catsByName = _.indexBy(data, 'categoryName')
    if (selected.length && !data.length) return []
    var assigned = selected.map(catName => {
        return createOption(catsByName[catName], nested)
    })
    return assigned
}

function createOptionStyle (styles, { data }) {
    if (!data.isChild) return styles
    return xtend(styles, { marginLeft: '1em' })
}

function createSelectOptions (cats, nested) {
    var asc = _.sortBy(cats, cat => cat.categoryName.toLowerCase())
    var sorted = sortByParent(asc, nested)
    return sorted.map(cat => createOption(cat, nested))
}

function createOption (cat, nested) {
    return {
        label: cat.categoryName,
        value: cat.categoryID,
        description: cat.categoryDescription,
        childrenLength: nested[cat.categoryID] ?
            Object.keys(nested[cat.categoryID]).length :
            null,
        isChild: !!cat.parentCategoryID,
        parentID: cat.parentCategoryID
    }
}

function formatOptionLabel (option, { context }) {
    if (context !== 'menu') return option.label

    var style = {
        display: 'flex',
        flexDirection: 'column',
    }

    var childCount = option.childrenLength ?
        <em>
            {' (' + option.childrenLength + ' child ' +
                (option.childrenLength === 1 ? 'category)' : 'categories)')}
        </em> :
        null


    return (<div style={style}>
        <div>
            {option.label}
            {childCount}
        </div>

        {option.description ?
            (<div style={{
                fontSize: 12,
                fontStyle: 'italic',
            }}>
                {option.description}
            </div>) :
            null
        }
    </div>);
};


const fixOptions = (data, nested) => {
    //when categories are added they need to be fixed on rerender
    //new example
    //{clientId:"1", categoryID:"1", categoryName:"name", childOf:"2", categoryDescription:"", isPublic:"1"}'
    let fixedData
    const fixedNested = Object.assign({}, nested)
    const newCategories = []
    const catIdsFound = {}
    fixedData = data.filter(category => {
        if (category.parentCategoryID === undefined) category.parentCategoryID = null
        if(!catIdsFound[category.categoryID]) {
            // could be new
            catIdsFound[category.categoryID] = true
            delete category.clientID
            if (category.isPublic) {
                delete category.isPublic
                newCategories.push(category)
            }
            if (category.childOf) {
                // add this to the nested if it isnt there alread
                category.parentCategoryID = category.childOf
                if (!fixedNested[category.childOf]) {
                    fixedNested[category.childOf] = {}
                }

                delete category.childOf
                fixedNested[category.parentCategoryID][category.categoryID] = category

            } else if (
                // check that 
                    category.parentCategoryID !== null &&
                    (fixedNested[category.parentCategoryID] && fixedNested[category.parentCategoryID][category.categoryID])
                ) {
                if (!fixedNested[category.parentCategoryID] && category.parentCategoryID) {
                    fixedNested[category.parentCategoryID] = {}
                }
                fixedNested[category.parentCategoryID][category.categoryID] = category

            }
            delete category.childOf
            return true
        } else if(category.clientID || catIdsFound[category.categoryID]){
            return false
        } else {
            // not new
            return true
        }
    })

    newCategories.forEach(category => {
        if (category.childOf) {
            // add to nested
            if (!fixedNested[category.childOf]) fixedNested[category.childOf] = {}
            fixedNested[category.childOf][category.categoryID] = {
                categoryID: category.categoryID,
                categoryName: category.categoryName,
                categoryDescription: category.categoryDescription,
                parentCategoryID: category.childOf
            }
        }
    })
    return [fixedData, fixedNested, newCategories]
}

const mapStateToProps = (state, ownProps) => {
    let { event, data } = ownProps
    const selectedCategoryNames = event.categories
    const { contentGroups, categories } = getContentGroupData(state)
    const isAssignedGroup = contentGroups.length
    // if the user is assigned a group hide all of the categories they don't have access to
    let hiddenSelectedCategories = []
    if (isAssignedGroup) {
        // hide but keep track of categories that are not in this users group but are selected
        hiddenSelectedCategories = data.filter(clientCategory => !categories.some(groupCategory => groupCategory.categoryID == clientCategory.categoryID) && selectedCategoryNames.includes(clientCategory.categoryName))
        data = data.filter(clientCategory => categories.some(groupCategory => groupCategory.categoryID == clientCategory.categoryID))
    }
    const selected = isAssignedGroup ? selectedCategoryNames : selectedCategoryNames.filter(name => !(hiddenSelectedCategories.some(hiddenCategory => hiddenCategory.categoryName === name)))
    const pendingCategories = getHasRequestPending(state, ['DATA/GET_CATEGORIES'])
    return { isAssignedGroup, data, hiddenSelectedCategories, selected, pendingCategories }
}

export default connect(mapStateToProps)(EventCategories)